module.exports = __webpack_public_path__ + "static/fiscal-responsibility-e044c904efb256f1ca6d88088043b8c0.jpg";